// @flow

import React, { Component } from 'react';

declare var APP:object;

/**
 * Implements a pre-meeting screen that can be used at various pre-meeting phases, for example
 * on the prejoin screen (pre-connection) or lobby (post-connection).
 */
export default class LeftScreen extends Component<Props> {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    rejoin() {
        window.location.reload();
    }

    gotoHome() {
        window.location.pathname = '/home/';
    }

    /**
     * Implements {@code PureComponent#render}.
     *
     * @inheritdoc
     */
    render() {
        
        return (
            <div className="left-screen">
                You have left the meeting <br/><br/>
                <div>
                    <div className="action-btn  primary" onClick={ this.rejoin }>Rejoin</div>
                    {/* <div className="action-btn  primary" onClick={ this.gotoHome }>Return to Home</div> */}
                </div>
            </div>
        );
    }
}
